export const selectReactApp = state => state.app;
export const selectReactAppMetadata = state => selectReactApp(state).metadata;



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/ReactApp/ReactAppSelectors.js